import React from "react";
import PortalSearchTable from "../../../../components/common/table/PortalSearchTable";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { convertDate, OptionTableCell, iTxt, TableButton } from "@duosoftbg/nacid-components";
import { useFormContext } from "react-hook-form";
import { NoMessage, YesMessage } from "../../../../../utils/constants";
import useAppDispatch from "../../../../../hooks/redux/base/useAppDispatch";
import { openModal } from "../../../../../store/redux/slice/ComponentsControl/globalMessageControl";
import { getI18n, useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd } from "@fortawesome/free-solid-svg-icons";

const headCells = [
  {
    id: "number",
    label: "l.table.head.number",
    sortable: false,
  },
  {
    id: "name",
    label: "l.table.head.name",
  },
  {
    id: "createdDate",
    label: "l.table.head.createdDate",
  },
  {
    id: "lastUpdateDate",
    label: "l.table.head.updatedDate",
  },
  {
    id: "type",
    label: "l.table.head.type",
    sortable: false,
  },
  {
    id: "active",
    label: "l.table.head.active",
    sortable: false,
  },
  {
    id: "options",
    label: "",
    sortable: false,
  },
];

const GlobalMessageListTable = ({ records, total, onPageOrOrderChange, blockTable, group, fetch }) => {
  const { getValues } = useFormContext();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const handleOpenModal = (id, modalType) => {
    const payload = { id, modalType };
    dispatch(openModal(payload));
  };

  return (
    <>
      <PortalSearchTable
        group={group}
        headCells={headCells}
        total={total}
        blockTable={blockTable}
        onPageOrOrderChange={onPageOrOrderChange}
      >
        <TableBody>
          {records.map((row, index) => {
            return (
              <TableRow hover key={row.id}>
                <TableCell>{index + 1 + getValues().page * getValues().pageSize}</TableCell>
                <TableCell>{row.name}</TableCell>
                <TableCell>{convertDate(row.createdDate)}</TableCell>
                <TableCell>{convertDate(row.lastUpdateDate)}</TableCell>
                <TableCell> {iTxt(getI18n().language, row.type.name, row.type.nameEn)}</TableCell>
                <TableCell>{row.active ? <YesMessage /> : <NoMessage />}</TableCell>
                <OptionTableCell>
                  <TableButton type={"view"} onClick={() => handleOpenModal(row.id, "view")} />
                  <TableButton type={"edit"} onClick={() => handleOpenModal(row.id, "edit")} />
                  {row.active && (
                    <TableButton type={"powerOff"} onClick={() => handleOpenModal(row.id, "changeVisibility")} />
                  )}
                  {!row.active && (
                    <TableButton type={"powerOff"} onClick={() => handleOpenModal(row.id, "changeVisibility")} />
                  )}
                  <TableButton type={"remove"} onClick={() => handleOpenModal(row.id, "delete")} />
                </OptionTableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </PortalSearchTable>
      <Button
        startIcon={<FontAwesomeIcon style={{ fontSize: 12 }} icon={faAdd} />}
        size={"medium"}
        type={"button"}
        variant="contained"
        color="secondary"
        onClick={() => handleOpenModal("", "edit")}
      >
        {t("l.btn.create.globalMessage")}
      </Button>
    </>
  );
};

export default GlobalMessageListTable;
